// code: ["A", "B", "C", "B", "B", "A"],
// chip: ["마감재", "집기", "마네킨", "영상", "간판/로고", "설비/누수/소방", "전기/조명", "음향", "소도구", "기타"],

import moment from "moment";
import { useEffect, useState } from "react";
import { useAppSelector } from "src/store/actions/action";
import { CONTRACT_AXIS, SHOP_TYPE_AXIS, axisOf, codeOfQualified } from "src/constants/storeAxis";

// code: ["1201000", "1202000", "1203000", "1206000", "1207000", "1208000", "1204000", "1205000", "1209000"],
const typeJSON = {
  마감재: "1201000",
  집기: "1202000",
  마네킨: "1203000",
  영상: "1206000",
  "간판/로고": "1207000",
  "설비/누수/소방": "1208000",
  "전기/조명": "1204000",
  음향: "1205000",
  소도구: "1210000",
  기타: "1209000",
  백화점: "A",
  대리점: "B",
  직영점: "C",
  상설: "O",
  아울렛: "OL",
  // 팩토리는 "F" 다. 2022년부터 "B"(대리점) 로 번역돼 팩토리 칩이 대리점 목록을 냈다 (VMD-396).
  // "F" 는 백엔드 StoreType enum 에 없고 운영 데이터에도 해당 매장이 0곳이라 빈 목록이 정답이다.
  팩토리: "F",
  면세점: "ADF",
  MLB: "M",
  "MLB KIDS": "I",
  Discovery: "X",
  "STRETCH ANGELS": "A",
  DUVETICA: "V",
  SUPRA: "W",
  "Sergio Tacchini": "ST",
  "1개월": "1",
  "3개월": "3",
  "6개월": 6,
  "12개월": 12,
  최신순: "DESC",
  오래된순: "ASC",
  가나다순: "ASC",
  제목순: "ASC",
  매장명순: "ASC",
  별점높은순: "DESC",
  별점낮은순: "ASC",
  이행률높은순: "DESC",
  이행률낮은순: "ASC",
  접수중: "as_20",
  업체배정: "as_40",
  견적진행: "as_60",
  "A/S진행": "as_80",
  완료: "as_100",
  취소: "as_0",
  0: "as_0",
  20: "as_20",
  40: "as_40",
  60: "as_60",
  80: "as_80",
  100: "as_100",
  일반공지: "1301000",
  "마네킨 착장": "1302000",
  매장연출: "1303000",
  "영상 ": "1304000",
  비주얼: "1305000",
  "기타 ": "1306000",
  이행: "Y",
  미이행: "N",
  "평가 전": "N",
  "평가 완료": "Y",
};

const brandToCode = (brand: string) => {
  switch (brand) {
    case "Discovery":
      return "X";
    case "MLB":
      return "M";
    case "MLB KIDS":
      return "I";
    case "STRETCH ANGELS":
      return "ST";
    case "DUVETICA":
      return "V";
    case "SUPRA":
      return "W";
    case "Sergio Tacchini":
      return "ST";
  }
};

const categoryGroup: any = {
  store: [],
  // 계약형태와 매장형태는 각각 독립된 필터 줄이다 (VMD-403). store 와 달리
  // 축 접두가 붙은 선택값으로 들어오므로 버킷을 따로 둔다.
  contractType: [],
  shopType: [],
  permanent: "",
  brand: [],
  date: [],
  category: [],
  process: [],
  manageSort: "",
  page: 0,
  contents: "",
  asSort: "",
  newStore: "",
  myExecute: "",
  fulfillSort: "",
  fulfillStore: [],
  execute: "",
  reExecute: "",
  assess: "",
  groupChannel: [], // 그룹채널 필터 추가
};

// 페이지 값이 숫자여서 다른 검색에 숫자가 있으면 안됨
// 값에 따라 array 배열 분기하여 등록
// typeSearchArray에 유형전체 데이터를 배열로 가지고옴
// contentsSearchString, sortSearchString, pageSearchNumber 요소 하나씩 가지고 옴
// pattern

const categoryGroupClass = (key: any, value: any) => {
  // filter.insert_date=$btw:2022-03-02,2022-03-02&filter.storeTypeCode.code_id=$in:A,B&search=롯&sortBy=open_date:ASC
  //   let queryFilter = "";
  if (key) {
    //typeSearchArray
    if (key === "groupChannelIdx") {
      // 그룹채널 group_part_idx 처리
      if (value && value.length > 0) {
        categoryGroup.groupChannel = value;
      }
    } else if (key === "typeSearchArray") {
      // 축 접두가 붙은 선택값을 먼저 가른다 (VMD-403). 아래의 라벨 whitelist 는
      // 두 축에 같은 라벨(`백화점`)이 있어서 구분하지 못하므로 그보다 먼저 와야 한다.
      if (axisOf(value) === CONTRACT_AXIS) {
        categoryGroup.contractType.push(value);
      } else if (axisOf(value) === SHOP_TYPE_AXIS) {
        categoryGroup.shopType.push(value);
      } else if ("백화점_대리점_직영점_상설_아울렛_팩토리_면세점".indexOf(value) > -1) {
        //   queryFilter = "filter.storeTypeCode.code_id=$in:";
        categoryGroup.store.push(value);
      } else if ("MLB_MLB KIDS_Discovery_STRETCH ANGELS_DUVETICA_SUPRA_Sergio Tacchini".indexOf(value) > -1) {
        //   queryFilter = "filter.brand=$in:";
        categoryGroup.brand.push(value);
      } else if (
        "마감재_집기_마네킨_영상_간판/로고_설비/누수/소방_전기/조명_음향_소도구_기타_일반공지_매장연출_마네킨 착장_영상 _비주얼_기타 _".indexOf(value) > -1
      ) {
        //   queryFilter = "filter.cate_idx=$in:";
        categoryGroup.category.push(value);
      } else if (String(value).indexOf("개월") > -1) {
        //   queryFilter = "filter.insert_date=$btw:";
        categoryGroup.date.push(value);
      } else if (String(value) === "기간선택") {
        //   queryFilter = "filter.insert_date=$btw:";
        categoryGroup.date.push(value);
      } else if ("접수중_업체배정_견적진행_A/S진행_완료_취소".indexOf(value) > -1) {
        categoryGroup.process.push(value);
      }
    } else if (key === "fulfillSearch") {
      if ("백화점_대리점_직영점_상설_아울렛_팩토리_면세점".indexOf(value) > -1) {
        //   queryFilter = "filter.store_user.store_type=$in:";
        categoryGroup.fulfillStore.push(value);
      } else if ("이행_미이행".indexOf(value) > -1) {
        categoryGroup.execute = value;
      } else if ("평가 전_평가 완료".indexOf(value) > -1) {
        categoryGroup.assess = value;
      }
    }
    // else if (key === "processSearchArray") {
    //   categoryGroup.process.push(value);
    // }
    else if (key === "contentsSearchString") {
      categoryGroup.contents = value;
    } else if (key === "sortSearchString") {
      categoryGroup.manageSort = value;
    } else if (key === "asSortSearchString") {
      categoryGroup.asSort = value;
    } else if (key === "fulfillSortSearchString") {
      categoryGroup.fulfillSort = value;
    } else if (key === "pageSearchNumber") {
      categoryGroup.page = value;
    } else if (key === "newStoreSearchString") {
      categoryGroup.newStore = value;
    } else if (key === "permanentSearchString") {
      categoryGroup.permanent = value;
    } else if (key === "reExecuteSearchString") {
      categoryGroup.reExecute = value;
    } else if (key === "myExecuteSearchString") {
      categoryGroup.myExecute = value;
    }
  }
};

const commaMark = (i: number, lastLength: number) => {
  let comma = "";
  if (i !== lastLength - 1) {
    comma = ",";
  }
  return comma;
};

const quaterTrans = (quaterValue: string) => {
  let returnQuater = "&";
  if (quaterValue === "?") {
    returnQuater = "&";
  } else if (quaterValue === "") {
    returnQuater = "?";
  }
  return returnQuater;
};

const urlReplace = (url: string) => {
  url = url.replace(/&/g, "%26").replace(/\+/g, "%2B");
  return url;
};

// 쿼리스트링 메인
const setQueryStringVer = (params: any, searchStartDate?: string, searchEndDate?: string, apiType?: string) => {
  // 글로벌 변수를 초기화
  categoryGroup.store = [];
  categoryGroup.contractType = [];
  categoryGroup.shopType = [];
  categoryGroup.permanent = "";
  categoryGroup.brand = [];
  categoryGroup.date = [];
  categoryGroup.category = [];
  categoryGroup.process = [];
  categoryGroup.manageSort = "";
  categoryGroup.asSort = "";
  categoryGroup.fulfillSort = "";
  categoryGroup.page = 0;
  categoryGroup.contents = "";
  categoryGroup.newStore = "";
  categoryGroup.myExecute = "";
  categoryGroup.fulfillStore = [];
  categoryGroup.execute = "";
  categoryGroup.assess = "";
  categoryGroup.groupChannel = [];
  // JSON 데이터를 받아서 처리
  const objectToStrong = JSON.stringify(typeJSON);
  const stringToJSON = JSON.parse(objectToStrong);
  let returnString = "";
  let quater = "";

  Object.entries(params).map((object: any, index: number) => {
    const key = object[0];
    const mapObject = object[1];
    // groupChannelIdx는 배열 전체를 한번에 처리
    if (key === "groupChannelIdx") {
      categoryGroupClass(key, mapObject);
    } else {
      // 배열
      if (typeof mapObject === "object") {
        if (mapObject.length > 0) {
          for (let i = 0; i < mapObject.length; i++) {
            categoryGroupClass(key, mapObject[i]);
          }
        }
      }
      if (typeof mapObject === "string") {
        if (mapObject !== "") {
          categoryGroupClass(key, mapObject.trim());
        } else {
          categoryGroupClass(key, "");
        }
      }
      if (typeof mapObject === "number") {
        if (mapObject !== 0) {
          categoryGroupClass(key, mapObject);
        }
      }
    }
  });

  if (categoryGroup.store.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.store_type=$in:";
    for (let i = 0; i < categoryGroup.store.length; i++) {
      returnString += stringToJSON[categoryGroup.store[i]] + commaMark(i, categoryGroup.store.length);
      //   if(i === (categoryGroup.store.length-1)){
      //   }else{
      //     returnString += stringToJSON[categoryGroup.store[i]] + ",";
      //   }
    }
  }

  // 계약형태는 단일 컬럼 비교라 paginate 의 filter 로 끝난다 (VMD-403).
  if (categoryGroup.contractType.length > 0) {
    const codes = categoryGroup.contractType.map((v: string) => codeOfQualified(v)).filter(Boolean);
    if (codes.length > 0) {
      quater = quaterTrans(quater);
      returnString += quater + "filter.contract_type_cd=$in:" + codes.join(",");
    }
  }

  // 매장형태는 paginate 의 filter 가 아니라 전용 파라미터다. 아울렛 집합이
  // 매장형태 L 또는 유통채널 07 이고 paginate 의 filter 는 AND 로 붙어 그 안에서
  // OR 를 표현할 수 없다. 백엔드 searchStore 가 shopTypes 를 받아 쿼리빌더에서
  // 괄호로 묶어 건다.
  if (categoryGroup.shopType.length > 0) {
    const codes = categoryGroup.shopType.map((v: string) => codeOfQualified(v)).filter(Boolean);
    if (codes.length > 0) {
      quater = quaterTrans(quater);
      returnString += quater + "shopTypes=" + codes.join(",");
    }
  }

  // 상설은 계약형태도 매장형태도 아닌 제3의 축이라 배타 칩이 아니라 토글이다.
  //
  // 값은 반드시 1 이다. `$eq:true` 로 보내면 안 된다 — is_permanent 는 TINYINT(1)
  // 이고 MySQL 이 문자열 'true' 를 숫자 0 으로 강제 변환하므로, 그 쿼리는
  // `is_permanent = 0` 이 되어 상설이 아닌 매장을 전부 돌려준다. 0건이 아니라
  // 정반대 집합이 나오므로 화면만 봐서는 틀린 줄 모른다. dev 실측(2026-10-26):
  // `$eq:true` 137건, `$eq:false` 137건, `$eq:1` 0건, `$eq:0` 137건.
  if (categoryGroup.permanent !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "filter.is_permanent=$eq:1";
  }

  if (categoryGroup.brand.length > 0) {
    if (apiType === "as") {
      quater = quaterTrans(quater);
      returnString += quater + "filter.store_user.brand=$in:";
      const temp = categoryGroup.brand.map((res: string) => brandToCode(res));
      returnString += temp.join(",");
    } else {
      quater = quaterTrans(quater);
      returnString += quater + "filter.brand=$in:";
      console.log(categoryGroup.brand);
      for (let i = 0; i < categoryGroup.brand.length; i++) {
        returnString += stringToJSON[categoryGroup.brand[i]] + commaMark(i, categoryGroup.brand.length);
      }
    }
  }

  if (categoryGroup.category.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.cate_idx=$in:";
    for (let i = 0; i < categoryGroup.category.length; i++) {
      returnString += stringToJSON[categoryGroup.category[i]] + commaMark(i, categoryGroup.category.length);
    }
  }

  if (categoryGroup.date.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.insert_date=$btw:";
    for (let i = 0; i < categoryGroup.date.length; i++) {
      if (categoryGroup.date[i] === "기간선택") {
        console.log("searchStartDate===============", searchStartDate);
        returnString += searchStartDate + "," + searchEndDate;
      } else {
        const startDate = moment().subtract(stringToJSON[categoryGroup.date[i]], "month").format("YYYY-MM-DD");
        // nestJS btw조건은 = 조건 포함 안되어서 react에서 하루 추가하여 데이터를 찾는다
        const result = new Date();
        result.setDate(result.getDate() + 1);
        const endDate = moment(result).format("YYYY-MM-DD");
        returnString += startDate + "," + endDate;
      }
    }
  }

  if (categoryGroup.process.length > 0) {
    quater = quaterTrans(quater);
    // 취소건이 생기면서 필터링 변경
    // returnString += quater + "filter.progress=$in:";
    returnString += quater + "filter.search_progress=$in:";
    for (let i = 0; i < categoryGroup.process.length; i++) {
      returnString += stringToJSON[categoryGroup.process[i]] + commaMark(i, categoryGroup.process.length);
    }
  }

  if (categoryGroup.manageSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.manageSort) > -1) {
      returnString += quater + "sortBy=open_date:";
    } else if ("가나다순".indexOf(categoryGroup.manageSort) > -1) {
      returnString += quater + "sortBy=name:";
    } else if ("별점높은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.score:";
    } else if ("별점낮은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.score:";
    } else if ("이행률높은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.execute_rate:";
    } else if ("이행률낮은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.execute_rate:";
    }
    returnString += stringToJSON[categoryGroup.manageSort];
  }

  if (categoryGroup.asSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=insert_date:";
    } else if ("가나다순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=contents:";
    } else if ("제목순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=title:";
    }
    returnString += stringToJSON[categoryGroup.asSort];
  }

  if (categoryGroup.fulfillSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.fulfillSort) > -1) {
      returnString += quater + "sortBy=insert_date:";
    } else if ("매장명순".indexOf(categoryGroup.fulfillSort) > -1) {
      returnString += quater + "sortBy=store_user.name:";
    } else if ("별점높은순".includes(categoryGroup.fulfillSort)) {
      returnString += quater + "sortBy=score:";
    } else if ("별점낮은순".includes(categoryGroup.fulfillSort)) {
      returnString += quater + "sortBy=score:";
    }
    returnString += stringToJSON[categoryGroup.fulfillSort];
  }

  if (categoryGroup.newStore !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "newStore=" + categoryGroup.newStore;
  }

  if (categoryGroup.myExecute !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "myExecute=" + categoryGroup.myExecute;
  }

  if (categoryGroup.page !== 0) {
    quater = quaterTrans(quater);
    returnString += quater + "page=" + categoryGroup.page;
  }

  // 페이지 사이즈를 1000으로 고정 설정
  quater = quaterTrans(quater);
  returnString += quater + "limit=1000";

  if (categoryGroup.contents !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "search=" + urlReplace(categoryGroup.contents);
  }

  if (categoryGroup.fulfillStore.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.store_user.store_type=$in:";
    for (let i = 0; i < categoryGroup.fulfillStore.length; i++) {
      returnString += stringToJSON[categoryGroup.fulfillStore[i]] + commaMark(i, categoryGroup.fulfillStore.length);
    }
  }

  if (categoryGroup.execute.length > 0) {
    quater = quaterTrans(quater);
    if ("이행_미이행".indexOf(categoryGroup.execute) > -1) {
      returnString += quater + "filter.execute_yn=$eq:";
    }
    returnString += stringToJSON[categoryGroup.execute];
  }

  if (categoryGroup.assess.length > 0) {
    quater = quaterTrans(quater);
    if ("평가 전_평가 완료".indexOf(categoryGroup.assess) > -1) {
      returnString += quater + "filter.assess_yn=$eq:";
    }
    returnString += stringToJSON[categoryGroup.assess];
  }

  if (categoryGroup.reExecute !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "filter.re_execute_yn=$eq:" + categoryGroup.reExecute;
  }

  // 그룹채널 필터 처리 - group_part_idx 사용
  if (categoryGroup.groupChannel.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.group_part_idx=$in:";
    returnString += categoryGroup.groupChannel.join(",");
  }

  return returnString;
};

export default setQueryStringVer;
